import type { QueryParamConfig } from 'use-query-params';
import { decodeDelimitedArray, encodeDelimitedArray } from 'use-query-params';

export const CommaArrayParam: QueryParamConfig<
  (string | null)[] | null | undefined
> = {
  encode: (array: (string | null)[] | null | undefined) =>
    encodeDelimitedArray(array?.length ? array : undefined, ','),
  decode: (arrayStr: string | (string | null)[] | null | undefined) =>
    decodeDelimitedArray(arrayStr, ','),
};
